import { avTone, initials } from '@/ui/format';
import type { ReactNode } from 'react';

/** Names stay readable; the decorative avatar gives employee rows a consistent anchor. */
export function PersonLabel({ id, name, children }: { id: number; name: string; children?: ReactNode }) {
  return (
    <span className="person-label">
      <span className={`av ${avTone(id)}`} aria-hidden="true">
        {initials(name)}
      </span>
      <span className="person-label-text">{children ?? name}</span>
    </span>
  );
}
